export interface StockItemReport {
  id: string;
  stockNo: string;
  productType: string;
  productKey: string;
  productOldCode: string;
  productDescription: string;
  balance: number;
  allocated: number;
  available: number;
  issued: number;
  despatched: number;
  balanceImperial: number;
  allocatedImperial: number;
  availableImperial: number;
  issuedImperial: number;
  pricePerUnit: number;
  value: number;
  warehouseKey: string;
  warehouseDescription: string;
  locationKey: string;
  locationDescription: string;
  gradeKey: string;
  gradeLevel: string;
  makeUpKey: string;
  makeUpDescription: string;
  batchNo: string;
  dateCreated: string;
  customerKey: string;
  customerName: string;
}
